<template>
  <v-col cols="12">
    <BaseTab>
      <v-tab>BALANÇO</v-tab>
      <v-tab>DEMAIS ARQUIVOS</v-tab>
      <v-tab-item class="py-10">
        <BaseButton
          :class="addDocumentClasses"
          @click="$emit('open-balance-modal')"
        >
          <v-icon class="pr-4 add-icon">fa-plus</v-icon>
          ADICIONAR DOCUMENTO
        </BaseButton>
        <p
          v-if="balanceDocumentsModel.documents.length > 0"
          class="darkGray--text body-1 mt-5 mb-2"
        >
          Últimos documentos adicionados
        </p>
        <DocumentDataTable
          v-bind="[$attrs]"
          v-on="$listeners"
          @preview-file="onPreviewFile"
          :documents="balanceDocumentsModel.documents"
        />
        <BaseErrorMessages
          v-if="balanceErrorMessages.length > 0"
          :error-messages="balanceErrorMessages"
        />
      </v-tab-item>
      <v-tab-item class="py-10">
        <v-row class="mb-10">
          <v-col cols="12" md="6" class="pr-md-5" v-if="exibeContratoSocial">
            <SingleDocumentInput
              label-text="Contrato Social"
              :value="documentsModel.contrato_social"
              item-name="contrato_social"
              v-on="$listeners"
            />
          </v-col>
          <v-col cols="12" md="6" v-if="exibeEstatuto">
            <SingleDocumentInput
              label-text="Estatuto"
              :value="documentsModel.estatuto"
              item-name="estatuto"
              v-on="$listeners"
            />
          </v-col>
        </v-row>
        <v-row class="mb-10">
          <v-col cols="12" md="6" class="pr-md-5" v-if="exibeAta">
            <SingleDocumentInput
              label-text="ATA"
              :value="documentsModel.ata"
              item-name="ata"
              v-on="$listeners"
            />
          </v-col>
          <v-col cols="12" md="6">
            <SingleDocumentInput
              label-text="Outros"
              :value="documentsModel.outros"
              item-name="outros"
              v-on="$listeners"
            />
          </v-col>
        </v-row>
      </v-tab-item>
    </BaseTab>
  </v-col>
</template>

<script>
import { mapState } from "vuex";
import { requiredInput } from "@/utils/rules.js";
import DocumentDataTable from "@/components/DocumentDataTable.vue";
import SingleDocumentInput from "@/components/form/SingleDocumentInput.vue";
import DocumentsMixin from "@/mixins/DocumentsMixin";
export default {
  name: "DocumentSelection",
  mixins: [DocumentsMixin],
  props: {
    value: { type: Object },
    balanceDocumentsModel: { type: Object },
    balanceErrorMessages: { type: Array },
    documentsModel: { type: Object }
  },
  components: {
    DocumentDataTable,
    SingleDocumentInput
  },
  data: () => ({ requiredInput }),
  computed: {
    ...mapState("me", ["myInfo"]),
    addDocumentClasses() {
      const noErrors = this.noErrors();
      return {
        secondary: noErrors,
        error: !noErrors,
        "text-uppercase": true,
        "subtitle-2": true,
        "font-weight-bold": true
      };
    },
    userArea() {
      return this.myInfo.area_usuario;
    },
    exibeAta() {
      return this.userArea.id == "garantia";
    },
    exibeContratoSocial() {
      return this.userArea.id == "garantia";
    },
    exibeEstatuto() {
      return this.userArea.id == "garantia";
    }
  },
  methods: {
    noErrors() {
      return this.balanceErrorMessages.length === 0;
    }
  }
};
</script>
